/**
 * The external dependencies.
 */
import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	flex: 1 1;
`;


// WEBPACK FOOTER //
// ./src/components/general/flex-root.js